import { useStories } from '~/composables/storyblok-proxy/useStories';
import type { FachkreisSearchPageStoryblok } from '~storyblok-types/FachkreisSearchPageStoryblok';

// Simple way to get the slug of the search page of a section without hardcoding it
export async function getSectionSearchPageSlug(): Promise<string> {
    const currentConfig = useCurrentSectionConfig();

    const params = computed(() => ({
        // last segment is 'config' so we remove it to get the section path
        starts_with: currentConfig.value?.configPath.split('/').slice(0, -1).join('/') ?? '',
        content_type: 'FachkreisSearchPage'
    }));

    const { data: stories } = await useStories<FachkreisSearchPageStoryblok>(params, {
        disableCountrySegment: true
    });

    return stories.value?.[0]?.full_slug?.split('/').pop() ?? 'search';
}
